import { isSalesTaxCountry } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";

export const useSalesTaxAvailability = (): { isSalesTaxManagementAvailable: boolean } => {
  const { organization } = useCurrentUserContext();

  return {
    isSalesTaxManagementAvailable: isSalesTaxCountry(organization?.country),
  };
};
